import { combineReducers } from 'redux';

import {
  getCurrentUserFail,
  getCurrentUserRequest,
  getCurrentUserSuccess,
  saveCurrentUserFail,
  saveCurrentUserRequest,
  saveCurrentUserSuccess,
  clearUserState,
} from '../actions';
import { CurrentUserState, UserAction } from '../types';
import { Reducer } from '../../../types';
import { User } from '../../../../types/items';

type ReducerOf<T extends keyof CurrentUserState> = Reducer<CurrentUserState, UserAction, T>;

const data: ReducerOf<'data'> = (state: User | null = null, action) => {
  switch (action.type) {
    case getCurrentUserRequest.type:
    case clearUserState.type:
      return null;

    case saveCurrentUserSuccess.type:
    case getCurrentUserSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = true, action) => {
  switch (action.type) {
    case getCurrentUserRequest.type:
    case saveCurrentUserRequest.type:
      return true;

    case getCurrentUserSuccess.type:
    case getCurrentUserFail.type:
    case saveCurrentUserSuccess.type:
    case saveCurrentUserFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case getCurrentUserFail.type:
      return true;

    case getCurrentUserSuccess.type:
    case getCurrentUserRequest.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<CurrentUserState>({
  data,
  loading,
  error,
});
